import {
    PMS_DIST_LOGIN_FAIL, PMS_DIST_LOGIN_RESPONSE,
    PMS_GENERATE_OTP_RESPONSE, PMS_GENERATE_OTP_FAIL, RESET_FORGOT_PASSWORD_RESPONSE, RESET_FORGOT_PASSWORD_FAIL

} from '../redux/types/pmsTypes'
import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import UserApi from "../services/userApi";
import AppApi from "../services/appApi";
let api = new UserApi();
let api2 = new AppApi()


export function* pmsDistibutLogin({ type, resolve, payload }) {

    let responsePayload = {};

    try {
        let { data } = yield api.PMSDistibutorLogin(payload);

        if (data.success) {
            responsePayload = data.data.userInfo;
            yield put({ type: PMS_DIST_LOGIN_RESPONSE, payload: responsePayload })
            yield put(push('/dashboard'));
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: PMS_DIST_LOGIN_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put(push('/pms'));
        yield put({ type: PMS_DIST_LOGIN_FAIL })
        resolve && resolve(e)

    }
}


export function* pmsGenerateOtp({ type, resolve, payload }) {

    let responsePayload = {};

    try {
        let { data } = yield api.PMSGenerateOtp(payload);

        if (data.success) {
            responsePayload = data;
            yield put({ type: PMS_GENERATE_OTP_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: PMS_GENERATE_OTP_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put({ type: PMS_GENERATE_OTP_FAIL })
        resolve && resolve(e)

    }
}

export function* resetPmsPassword({ type, resolve, payload }) {

    let responsePayload = {};

    try {
        let { data } = yield api.ResetForgetPassword(payload);

        if (data.success) {
            responsePayload = data;
            yield put({ type: RESET_FORGOT_PASSWORD_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: RESET_FORGOT_PASSWORD_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put({ type: RESET_FORGOT_PASSWORD_FAIL })
        resolve && resolve(e)

    }
}
